import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilityService {

    public localeText = {
        page: 'صفحه',
        more: 'بیشتر',
        to: 'به',
        of: 'از',
        and: 'و',
        or: 'یا',
        next: 'بعدی',
        last: 'آخر',
        first: 'اول',
        previous: 'قبلی',
        loadingOoo: 'در حال بارگذاری...',
        selectAll: 'انتخاب همه',
        searchOoo: 'جستجو...',
        blanks: 'خالی',
        filterOoo: 'فیلتر...',
        applyFilter: 'اعمال فیلتر...',
        equals: 'برابر',
        notEqual: 'غیر برابر',
        notEquals: 'غیر برابر',
        lessThan: 'کوچکتر از',
        greaterThan: 'بزرگتر از',
        lessThanOrEqual: 'کوچکتر یا مساوی',
        greaterThanOrEqual: 'بزرگتر یا مساوی',
        inRange: 'در محدوده',
        contains: 'شامل بودن',
        notContains: 'شامل نبودن',
        startsWith: 'شروع با',
        endsWith: 'اتمام با',
        group: 'گروه',
        noRowsToShow: 'داده ای برای نمایش وجود ندارد',
        copy: 'کپی',
        copyWithHeaders: 'کپی با تیترها',
        ctrlC: 'Ctrl + C',
        paste: 'الصاق',
        ctrlV: 'Ctrl + V',
        columns: 'ستون ها',
        filters: 'فیلترها',
        rowGroupColumns: 'گروه بندی بر اساس ستون',
        rowGroupColumnsEmptyMessage: 'برای گروه بندی ستون را اینجا بکشید',
        valueColumns: 'گروه بندی بر اساس مقادیر',
        pivotMode: 'حالت پیوت',
        groups: 'گروه ها',
        values: 'مقادیر',
        pivots: 'پیوت ها',
        valueColumnsEmptyMessage: 'برای جمع بندی ستون را اینجا بکشید',
        pivotColumnsEmptyMessage: 'برای پیوت ستون را اینجا بکشید',
        toolPanelButton: 'ابزارها',
        pinColumn: 'ستون ثابت',
        valueAggregation: 'جمع مقادیر',
        autosizeThiscolumn: 'تنظیم اندازه این ستون',
        autosizeAllColumns: 'تنظیم اندازه همه ستون ها',
        groupBy: 'گروه بندی',
        ungroupBy: 'حذف گروه بندی',
        resetColumns: 'اندازه پیش فرض ستون ها',
        expandAll: 'باز کردن همه',
        collapseAll: 'بستن همه',
        toolPanel: 'پنل ابزارها',
        export: 'خروجی گرفتن',
        csvExport: 'خروجی CSV',
        excelExport: 'خروجی Excel',
        pinLeft: 'ثابت سمت چپ',
        pinRight: 'ثابت سمت راست',
        noPin: 'ثابت نباشد',
        sum: 'جمع',
        min: 'کمترین',
        max: 'بیشترین',
        none: 'هیچ کدام',
        count: 'تعداد',
        avg: 'میانگین'
    };

    formatNumber(params, prefix: string = "") {
        if (params && typeof(params) === 'object') {
            if (params.value) return Number(params.value).toFixed().toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + ` ${prefix}`;
            else return;
        }
        if (params && (typeof(params) === 'number' || typeof(params) === 'string')) {
            if (params) return Number(params).toFixed().toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + ` ${prefix}`;
            else return;
        }
    }

    calcPercent(num: number, percent: number): string | number {
        return ((num / 100) * percent).toFixed();
    }

    touchDevice(): boolean {
        return Boolean('ontouchstart' in window) || Boolean(navigator.maxTouchPoints);
    }

    escape(str): string {
        return (str + '').replace(/"+/g, "'");
    }

    unescape(str): string {
        return (str + '').replace(/'+/g, '"');
    }
}
